export default __webpack_public_path__ + "static/newsletter-df4c01d03604951709f2bbbbf9f481cd.svg";